import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Tests from '@/views/tests/Tests';

import SoilTestsRouter from './soil.router'
import WaterTestsRouter from './water.router'
import TissueTestsRouter from './tissue.router'
import MediaAnalysisRouter from './mediaanalysis.router'

export default {
  path: 'tests',
  component: Tests,
  name: 'tests',
  meta: { title: 'Tests' },
  beforeEnter: multiguard([
    middleware.hasPlan, 
    middleware.isNotSuperImpact
  ]),
  children: [
    SoilTestsRouter,
    WaterTestsRouter,
    TissueTestsRouter,
    MediaAnalysisRouter,
  ]
};
